import { useTimezone } from "@app/hooks/timezone";
import moment from "moment";
import moment_timezone from "moment-timezone";
import React from "react";
import { Text } from "@/styles/reactnative";
import { useIsMobile } from '@utils/CalVW.tsx';

const EntryTime = ({
  time,
  format = "YYYY-MM-DD HH:mm:ss",
  style = {
    fontSize: 14,
    letterSpacing: -1,
  },
  relative = false,
  relativeAdd = false,
  offset = 0,
}: any) => {
  const printtime = useTimezone(time, format, 0);
  const isMobile = useIsMobile();

  if (!time) return <></>;
  let displayTime;

  if (relative) {
    const now = moment();
    const diffMonths = now.diff(time, "months");
    if (diffMonths >= 12) {
      const diffYears = Math.floor(diffMonths / 12);
      const remainingMonths = diffMonths % 12;
      displayTime = `${diffYears}Year ${remainingMonths}Month Ago`;
    } else if (diffMonths > 1) {
      displayTime = `${diffMonths}Month`;
    } else {
      const diff = moment.duration(moment().diff(moment(time)));

      if (diff.asDays() > 1) {
        displayTime = `${Math.floor(diff.asDays())} days ago`;
      } else if (diff.asHours() > 0) {
        displayTime = `${Math.floor(diff.asHours())} hours ago`;
      } else if (diff.asMinutes() > 0) {
        displayTime = `${Math.floor(diff.asMinutes())} minutes ago`;
      } else {
        displayTime = `${Math.floor(diff.asSeconds())} seconds ago`;
      }
    }
  }

  return (
    <>
      {relativeAdd ? (
        <>
          <Text style={style} size={14}>{printtime}</Text>
          {relative && <Text style={style} size={14}>{displayTime}</Text>}
        </>
      ) : isMobile ?
        (
          <>
            <div style={style}>{printtime}</div>
            {relative && <div style={style} >{displayTime}</div>}
          </>
        )
        :
        (
        <>
          <Text style={style} size={14}>{relative ? displayTime : printtime}</Text>
        </>
      )}
    </>
  );
};

export default React.memo(EntryTime);
